<template>
  <div>
     

      <v-row no-gutters>
          <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
              <v-card tile outlined style="padding-top:200px" height="100vh">
                  <h2 class="ml-14 mt-14">Zaastry Rewards</h2>
                  <h3 class="ml-14 mt-5">My Rewards</h3>
                   <h3 class="ml-14">How it works</h3>
                 
              </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7">
              <v-card tile outlined height="100vh" class="grey lighten-4">
                 <h5 class="pa-10">REWARD STATUS</h5>
                 <h1 v-if="rewarding" class="text-center">{{reward.balance}}<v-icon class="yellow--text text--darken-3 mb-1">mdi-star</v-icon></h1>
                  <h1 v-else class="text-center">0<v-icon class="yellow--text text--darken-3 mb-1">mdi-star</v-icon></h1>
                 <Slider :info="reward.balance" />
                    <h5 class="grey--text text-center">ZAASTRY BALANCE</h5>
                    <v-card outlined class="" width="300px" style="margin-left:240px; margin-top:20px">
                            
                      <h5 class="font-weight-regular grey lighten-4">start collecting points towards free drinks, food and more.</h5>
                  </v-card>
                  <v-divider class="mt-14"></v-divider>
                  <v-row>
                      <v-spacer></v-spacer>
                    <v-col cols="12" lg="5" class="mt-10">
                  <h2>Zaastry Codes</h2>
                  <v-text-field outlined dense placeholder="Enter your Zaastry Code"></v-text-field>
                  <p class="text-end"><v-btn style="border-radius:50px" outlined>submit</v-btn></p>
                  </v-col>
                  <v-spacer></v-spacer>
                  </v-row>
              </v-card>
          </v-col>
      </v-row>
  </div>
</template>

<script>
import axios from 'axios'

import Slider from '../components/Rewards/Slider.vue'
export default {
  components: {Slider },
  data(){
    return {
      reward:{},
      rewarding:false

    }
  },
  mounted(){
    axios.get('https://zaastry-node.herokuapp.com/loyalty').then(res=>{
      console.log(res.data)
      console.log(this.$store.state.customer.customerid)
      let re=res.data
      for(var i=0;i<re.length;i++){
        if(re[i].customerId==this.$store.state.customer.customerid){
          this.reward=re[i]
          this.rewarding=true
        }
      }
    })
  }

}
</script>

<style>

</style>